<template>
    <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
        <div v-if="status === 'started' && !otpCompleted">
            <v-row>
                <v-card-text>
                    <v-container class="ma-0 pa-0 mw-100">
                        <p v-text="$t('Authenticate.KeySendMessage_1')" class="text-center mb-0"></p>
                        <p v-text="$t('Authenticate.KeySendMessage_2')" class="text-center mb-0"></p>
                        <p v-text="$t('Authenticate.KeySendMessage_3')" class="text-center"></p>
                    </v-container>
                    <v-row justify="center">
                        <v-col cols="12" sm="5" md="5">
                            <v-otp-input v-model="otp" @finish="focusSubmit" :label="$t('Authenticate.EnterCode')" type="number"></v-otp-input>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" sm="5" md="5">
                            <p class="text-center ma-0 pa-0 caption">
                                {{ $t("Authenticate.reference") }}{{ reference }}
                            </p>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" sm="5" md="5">
                            <p class="text-center ma-0 pa-0 caption">
                                <v-btn color="primary" @click="retrySMS" plain :disabled="disableRetry">
                                    <span style="white-space: normal;">{{ $t("Authenticate.NotReceivedCodeLink") }}
                                    </span>
                                </v-btn>
                            </p>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-row>
            <v-row v-if="smsSend" justify="center">
                <v-col cols="12" sm="12" align="center">
                    <base-timer ref="timer" :time="time"></base-timer>
                </v-col>
            </v-row>
            <v-col cols="12" sm="8" class="text-right">
                <custom-button :text="$t('Headers.confirm')" @click="checkSMS" :disabled="checkingSms"></custom-button>
            </v-col>
        </div>
        <v-row justify="center" v-if="status === 'started' && otpCompleted">
            <v-col cols="12">
                <p :color="mainColor"> {{ $t('Authenticate.uploaded_file_info_text') }} </p>
            </v-col>
            <v-col cols="12">
                <drag-and-drop @files="uploadFile" :multiple="false" />
                <v-row justify="center">
                    <v-col cols="12" sm="12">
                        <v-data-table :headers="headers" :items="signedFile" item-key="file_name" :items-per-page="5"
                            class="elevation-1" :footer-props="{
                                disableItemsPerPage: true,
                                itemsPerPageOptions: [],
                                itemsPerPageText: '',
                            }">
                            <template v-slot:[`item.delete`]="{ item }">
                                <v-icon medium @click="removeFile(item)"> mdi-delete</v-icon>
                            </template>

                            <template v-slot:no-data>
                                {{ $t('Headers.no_data') }}
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="text-right">
                <custom-button id="sign" :text="$t('Authenticate.commit_document')" @click="startProcess"></custom-button>
            </v-col>
        </v-row>
        <v-row v-if="status === 'document_uploaded'">
            <v-col cols="12" sm="12">
                <info-alert :text="$t('Authenticate.request_uploaded')" :color="mainColor" />
            </v-col>
        </v-row>
        <v-row v-if="status === 'undefined'">
            <v-col cols="12" sm="12">
                <info-alert :text="$t('Authenticate.request_declined')" :color="mainColor" />
            </v-col>
        </v-row>
        <v-row v-if="status === 'approved'">
            <v-col cols="12" sm="12">
                <info-alert :text="$t('Authenticate.request_approved')" :color="mainColor" />
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import TitleMedium from "@/components/ui/text/HeaderMedium.vue";
import CustomButton from '@/components/ui/input/CustomButton';
import DragAndDrop from "@/components/ui/input/DragAndDrop.vue";
import InfoAlert from "../../components/ui/other/InfoAlert";
import BaseTimer from "../../components/ui/other/BaseTimer.vue";
import i18n from "@/i18n";
import { log } from "@/helpers/logger";

export default {
    name: "qes-identify-exisiting-upload",
    components: {
        TitleMedium,
        CustomButton,
        DragAndDrop,
        InfoAlert,
        BaseTimer
    },
    props: ["signer_id"],
    data() {
        return {
            headers: [
                { text: i18n.t('Headers.name'), value: 'name' },
                { text: '', value: 'delete', sortable: false },
            ],
            signedFile: [],
            fileRaw: {},
            fileUploaded: false,
            status: {},
            mainColor: this.$vuetify.theme.themes.light.primary,
            status: "",
            otpCompleted: false,
            otp: "",
            time: 0,
            disable: false,
            disableRetry: true,
            smsSend: false,
            checkingSms: false,
        };
    },
    created: async function () {
        this.$emit("step", 3);
        await this.checkStatus()
        if (this.status === 'started') {
            this.getSMS()
        }
    },
    computed: {
        reference() {
            return this.$store.state.data.reference;
        },
    },
    methods: {
        focusSubmit() {
     document.getElementById("sign").focus();
    }, 
        getSMS: async function () {
            var app = this;
            await this.$store
                .dispatch("data/getRequestSMS", this.signer_id)
                .then(() => {
                    this.smsSend = true;
                })
                .catch((err) => {
                    log("AesAuthenticate.created() - " + err, 'error');
                    return;
                }).finally(() => {
                    setTimeout(function () {
                        app.disableRetry = false;
                    }, 60000);
                });
        },
        retrySMS: async function () {
            this.time = 0;

            this.disableRetry = true;

            var app = this;

            await this.$store.dispatch("data/retrySMS", this.signer_id).finally(() => {
                this.time = 300;
                setTimeout(function () {
                    app.disableRetry = false;
                }, 60000);
            });
        },
        checkSMS: async function () {
            this.checkingSms = true
            let data = {
                auth_token: this.$store.state.data.auth_token,
                otp: this.otp,
                signer_id: this.signer_id,
            }
            await this.$store.dispatch("data/checkRequestSMS", data).then((responseData) => {
                this.otpCompleted = responseData
            })
        },
        checkStatus: async function () {
            let data = {
                signer_id: this.signer_id
            }
            await this.$store
                .dispatch("data/checkRequestStatus", data)
                .then(async (data) => {
                    log(
                        "QesIdentifyExisting.index.checkRequestStatus() - check Status of Request for " +
                        this.signer_id,
                        "info"
                    )
                    this.status = data.request_state
                })
                .catch((err) => {
                    log("QesIdentifyExisting.index.checkRequestStatus() - " + err, "error");
                });
        },
        startProcess: async function () {
            let data = {
                signer_id: this.signer_id,
                fileRaw: this.fileRaw,
            }
            await this.$store
                .dispatch("data/uploadFile", data)
                .then(async () => {
                    log(
                        "QesIdentifyExisting.index.getFileToSign() - upload File " +
                        this.signer_id,
                        "info"
                    )
                    this.status = "document_uploaded"
                })
        },
        async uploadFile(val) {
            try {
                this.signedFile = val
                const file = val[0].file;
                const reader = new FileReader();
                reader.onload = () => {
                    // Read the file data as an ArrayBuffer
                    const fileData = reader.result;
                    // Create a Blob object from the ArrayBuffer
                    const blob = new Blob([fileData], { type: 'application/pdf' });

                    // Read the Blob as a data URL, which will be a base64-encoded string
                    const dataUrlReader = new FileReader();
                    dataUrlReader.onload = () => {
                        // Get the base64-encoded string from the data URL
                        const base64Data = dataUrlReader.result.split(',')[1];

                        // Convert the base64 string back to a Buffer
                        const buffer = Buffer.from(base64Data, 'base64');

                        this.fileRaw = buffer
                    };
                    dataUrlReader.readAsDataURL(blob);
                };
                reader.readAsArrayBuffer(file);
                this.fileUploaded = true
            } catch (err) {
                console.log(err)
            }
        },
    }
}
</script>